import React, { useEffect, useState } from 'react';
import { Text } from '../../app-components';
import vars from '../../theme/vars';
import { Form } from '../../app-components/form/Form';
import { invoke } from '../../AppServices';
import { modifyDateView } from '../../Lib/helpers';
import { getAppraisalRecordURI } from '../../Queries/dealer';

export const ViewAppraisalResult = (props) => {
  const { navigation, id } = props;


  // let id   
  // useEffect(() => {

  //   // Parse the query parameters from the URL
  //   const params = new URLSearchParams(window.location.search);
    
  //   // Get the 'data' parameter
  //   const dataParam = params.get('data');

  //   // Parse the 'data' parameter into a JavaScript object
  //   const parsedData = dataParam ? JSON.parse(decodeURIComponent(dataParam)) : null;

  //   // Set the data in the component state
  //   id = parsedData;

  //   // ... rest of your component code

  // }, []); // The empty dependency arra

  const appraisalDetails = [];
  const dealerDetails = [];
  const customerDetails = [];
  const vehicleDetails = [];
  const counterDetails = [];

  appraisalDetails.push({
    label: 'Stock#',
    type: 'text',
    field: 'uci.stockNumber',
    editable: false,
    visible: ({ data }) => data.type === 'uci',
  });

  appraisalDetails.push({
    label: 'Contract Date',
    type: 'text',
    editable: false,
    render: ({ data }) => (
      <Text style={{ fontSize: 17 }}>
        {data?.uci?.contractDate
          ? modifyDateView(data?.uci?.contractDate)
          : '--'}
      </Text>
    ),
    visible: ({ data }) => data.type === 'uci',
  });

  appraisalDetails.push({
    label: 'Appraisal#',
    type: 'text',
    field: 'dms.repairOrderNumber',
    editable: false,
  });

  appraisalDetails.push({
    label: 'Repair Order Open Date',
    type: 'text',
    editable: false,
    render: ({ data }) => (
      <Text style={{ fontSize: 17 }}>
        {modifyDateView(data?.dms?.openDate)}
      </Text>
    ),
  });

  appraisalDetails.push({
    label: 'Range Generated',
    type: 'text',
    field: 'finalRange',
    editable: false,
  });

  appraisalDetails.push({
    label: 'Original Wholesale Value',
    type: 'text',
    field: 'originalValue',
    editable: false,
  });

  appraisalDetails.push({
    label: 'Spread',
    type: 'text',
    editable: false,
    render: ({ data }) => (
      <Text style={{ fontSize: 17 }}>{`${data?.spread} %`}</Text>
    ),
  });

  appraisalDetails.push({
    label: 'Enhancement',
    type: 'text',
    editable: false,
    render: ({ data }) => (
      <Text style={{ fontSize: 17 }}>{`${data?.enhance} %`}</Text>
    ),
  });

  // creating dealer details array
  dealerDetails.push({
    label: 'Name',
    type: 'text',
    field: 'dealer.name',
    editable: false,
  });

  dealerDetails.push({
    label: 'Dealer Management System',
    type: 'text',
    field: 'dealer.dms',
    editable: false,
  });

  // creating customer details array
  customerDetails.push({
    label: 'Name',
    type: 'text',
    field: 'dms.name',
    editable: false,
  });

  customerDetails.push({
    label: 'Email',
    type: 'text',
    field: 'dms.email',
    editable: false,
  });

  customerDetails.push({
    label: 'Contact Number',
    type: 'text',
    field: 'dms.contactNumber',
    editable: false,
  });

  // creating vehicle details aray
  vehicleDetails.push({
    label: 'Model',
    type: 'text',
    field: 'dms.model',
    editable: false,
  });

  vehicleDetails.push({
    label: 'Make',
    type: 'text',
    field: 'dms.make',
    editable: false,
  });

  vehicleDetails.push({
    label: 'Year',
    type: 'text',
    field: 'dms.year',
    editable: false,
  });

  vehicleDetails.push({
    label: 'Mileage',
    type: 'text',
    field: 'dms.mileage',
    editable: false,
  });

  vehicleDetails.push({
    label: 'VIN',
    type: 'text',
    field: 'dms.vin',
    editable: false,
  });

  // counter array
  counterDetails.push({
    label: 'From AV Fail Counter',
    type: 'text',
    field: 'dms.fromAVFail',
    editable: false,
  });

  counterDetails.push({
    label: 'From Auto Counter',
    type: 'text',
    field: 'dms.fromAuto',
    editable: false,
  });

  counterDetails.push({
    label: 'From RO List Counter',
    type: 'text',
    field: 'dms.fromROList',
    editable: false,
  });

  return (

    <>
     {/* ... (other components) */}
    <Form
      type="standard"
      uri={getAppraisalRecordURI(id)}
      onSubmit={async ({ data }) => {
        await invoke({
          id: 'saveDealerNote',
          paramValue: {
            itemId: navigation?.state?.params?.item?._id,
            dealerNote: data.dealerNote,
          },
        });
      }}
      fieldContainer="topLabel"
      lg={{
        formGroups: [
          {
            columnsPerRow: 2,
            fieldVariant: 'filled',
            label: 'Appraisal Details',
            labelStyle: {
              ...vars.headings.h8,
              color: vars.colors.grey.color2,
              textTransform: 'uppercase',
            },
            groupsContainerStyle: {
              borderTop: `1px solid${vars.colors.grey.color2}`,
            },
            groups: [
              {
                columns: appraisalDetails,
              },
            ],
          },

          {
            columnsPerRow: 2,
            fieldVariant: 'filled',
            label: 'Dealer Details',
            labelStyle: {
              ...vars.headings.h8,
              color: vars.colors.grey.color2,
              textTransform: 'uppercase',
            },
            groupsContainerStyle: {
              borderTop: `1px solid${vars.colors.grey.color2}`,
            },
            groups: [
              {
                columns: dealerDetails,
              },
            ],
          },

          {
            columnsPerRow: 2,
            fieldVariant: 'filled',
            label: 'Customer Details',
            labelStyle: {
              ...vars.headings.h8,
              color: vars.colors.grey.color2,
              textTransform: 'uppercase',
            },
            groupsContainerStyle: {
              borderTop: `1px solid${vars.colors.grey.color2}`,
            },
            groups: [
              {
                columns: customerDetails,
              },
            ],
          },
          {
            columnsPerRow: 2,
            fieldVariant: 'filled',
            label: 'Vehicle Details',
            labelStyle: {
              ...vars.headings.h8,
              color: vars.colors.grey.color2,
              textTransform: 'uppercase',
            },
            groupsContainerStyle: {
              borderTop: `1px solid${vars.colors.grey.color2}`,
            },
            groups: [
              {
                columns: vehicleDetails,
              },
            ],
          },

          {
            columnsPerRow: 2,
            fieldVariant: 'filled',
            groupsContainerStyle: {
              borderTop: `1px solid${vars.colors.grey.color2}`,
            },
            groups: [
              {
                columns: [
                  {
                    label: "Dealer's Note",
                    type: 'textArea',
                    field: 'dealerNote',
                    description:
                      'If you want note something. Please write here!',
                    placeholder:
                      'If you want note something. Please write here!',
                    editable: true,
                    allowWhiteSpaces: true,
                    minHeight: 100,
                    style: { flex: 1, overflow: 'hidden' },
                  },
                ],
              },
            ],
          },
        ],
      }}
      {...props}
    />
    </>
  );
};
